export default __webpack_public_path__ + "static/Konzierge_complete_logo_positive-02a60d454a974aef952d9fb6e5e1e546.webp";